import styled from 'styled-components';
import { marginBottom, themeColor } from '@whitelabel/helpers/style';
import { Alert } from '@whitelabel/component-library';
import FormikFormField from '../../FormikFormField';

export const StyledAlert = styled(Alert)`
  ${marginBottom};
  .link {
    color: ${themeColor('info')};
    &:hover {
      color: ${themeColor('info')};
      text-decoration: none;
      box-shadow: 0 -2px 0 0 ${themeColor('info')} inset;
    }
  }
`;

export const StyledFormikFormField = styled(FormikFormField)`
  ${marginBottom};
`;
